import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'
import FiltroPanel from './filtro-panel'
import ResumenGeneral from './resumen-general'
import { obtenerResumenIntercia, setFiltrosIntercia } from '../../store/actions/dashboard-intercia-action'
import { buildQuery, rangoContableInicial } from '../../common/dashboard-utils'

/**
 * Tablero de Control — Pagos Inter Compañía. **Drop 2026-09-22 (RG-541)**.
 *
 * 🔴 El filtro de período pasó de un rango de meses a un rango de fechas exactas, así que ya no
 *    depende de `meses-disponibles`: arranca directo con el rango contable 10→10 de la fecha
 *    actual (`rangoContableInicial`).
 */
const DashboardInterCIA = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const filtros = useSelector((state) => state.dashboardInterciaReducer.filtros)
    const porCiaPagado = useSelector((state) => state.dashboardInterciaReducer.resumen?.porCiaPagado || [])
    const porCiaPendientes = useSelector((state) => state.dashboardInterciaReducer.resumen?.porCiaPendientes || [])

    // 🔒 El combo de compañías se arma con lo que trae el propio resumen — decisión del usuario
    //    (02-09-2026): solo debe ofrecer compañías con casos en el período consultado.
    //    Se combinan DOS arrays (pagado + pendientes de gestión), porque el `porCia` único
    //    desapareció desde la V1.1. El `Map` deduplica por `companiaId`.
    const companias = Array.from(
        new Map(
            [...porCiaPagado, ...porCiaPendientes]
                .filter((c) => c.companiaId)
                .map((c) => [c.companiaId, { id: c.companiaId, nombre: c.compania }])
        ).values()
    )

    const cargarDatos = () => {
        setLoading(true)
        dispatch(obtenerResumenIntercia(buildQuery(filtros))).finally(() => setLoading(false))
    }

    useEffect(() => {
        const inicial = rangoContableInicial()
        dispatch(setFiltrosIntercia(inicial))

        setLoading(true)
        dispatch(obtenerResumenIntercia(buildQuery({ ...filtros, ...inicial })))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    return (
        <div>
            <LoadingComponent show={loading} />
            <Container fluid className='py-3'>
                <Card>
                    <Card.Header as='h6' className='text-center' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        Tablero de Control — Pagos Inter Compañía
                    </Card.Header>
                    <Card.Body>
                        <FiltroPanel onBuscar={cargarDatos} companias={companias} />
                        {!loading && <ResumenGeneral />}
                    </Card.Body>
                </Card>
            </Container>
        </div>
    )
}

export default DashboardInterCIA
